import React from 'react';
import {connect} from "react-redux";
import NavbarAuth from "./NavbarAuth";
import {NavbarNonAuth} from "./NavbarNonAuth";
import './styles.css';

/**
 * Navigation bar component.
 * @param authUser - current authenticated user.
 */
const Navbar = ({authUser}) => {
    return (
        <nav className="navbar fixed-top navbar-expand-sm navbar-dark bg-navbar">
            {authUser ? <NavbarAuth/> : <NavbarNonAuth/>}
        </nav>
    );
};

/**
 * Map Redux {@param state} to component props
 */
const mapStateToProps = (state) => ({
    authUser: state.sessionState.authUser
});

export default connect(mapStateToProps)(Navbar);



// WEBPACK FOOTER //
// ./src/components/navigationbar/Navbar.jsx